import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginToken: '',
    activeStep: 1,
    userInfos: {},
    insuranceInfos: {},
    persons: [
      {
        birthDate: '',
        currentInsuranceCompany: null,
        petType: '',
        Deductible: '',
        InsuredSum: '',
        startOfInsurance: '',
        hereditaryDiseases: false,
      },
    ],
    allOffers: [],
  },
  mutations: {
    mutateActiveStep(state, payload) {
      state.activeStep = payload;
    },
    mutateNewPerson(state, payload) {
      state.persons.push(payload);
    },
    mutateRemovePerson(state, payload) {
      state.persons.splice(payload, 1);
    },
    mutateUserInfos(state, payload) {
      state.userInfos = { ...payload };
    },
    mutateInsuranceInfos(state, payload) {
      state.insuranceInfos = { ...payload };
    },
    mutateOffers(state, payload) {
      state.allOffers = payload;
    },
    mutatePersonOffers(state, payload) {
      state.persons[payload.index].offers = payload.offers;
    },
    mutateSelectedOffer(state, payload) {
      state.persons.forEach((person, index) => {
        state.persons[index].selectedOffer = payload;
      });
    },
  },
  actions: {
    setActiveStep({ commit }, stepNumber) {
      commit('mutateActiveStep', stepNumber);
    },
    setNewPerson({ commit }, person) {
      commit('mutateNewPerson', person);
    },
    setRemovePerson({ commit }, personIndex) {
      commit('mutateRemovePerson', personIndex);
    },
    setUserInfos({ commit }, infos) {
      commit('mutateUserInfos', infos);
    },
    setInsuranceInfos({ commit }, infos) {
      commit('mutateInsuranceInfos', infos);
    },
    setOffers({ commit }, offers) {
      commit('mutateOffers', offers);
    },
    setPersonOffers({ commit }, { offers, index }) {
      commit('mutatePersonOffers', { offers, index });
    },
    setSelectedOffer({ commit }, offer) {
      commit('mutateSelectedOffer', offer);
    },
  },
});
